import { Application, AuthManager, Managers } from '@levelapp/softfabric';
import Cookies from 'universal-cookie';

export function getToken() {
    const cookies = new Cookies();
    const token: string|undefined = cookies.get('token');

    if (token) {
        const authData = {
            access_token: token,
            refresh_token: "484FBDF368636A5475785F3276BFEBAEDC41A4D976C486DB58923475C95E8159",
            expires_in: 3600,
            token_type: "Bearer",
            scope: "app_api identity_api offline_access openid"
        };

        const auth: AuthManager = Application.current.resolve(Managers.AUTH_MANAGER);
        auth.setToken(authData);
        localStorage.setItem("token", JSON.stringify(authData));
    }

    return token;
}

export function clearToken() {
    const cookies = new Cookies();
    cookies.remove('token', { path: '/', domain : '.beebonds.com' });  
    localStorage.removeItem("token");

    const auth: AuthManager = Application.current.resolve(Managers.AUTH_MANAGER);
    auth.clearToken();
}